
export default {
  name: 'CategoryGrid',
  props: {
    categories: {
      type: Array,
      required: true
    }
  }
}
